const data = [

    {
        name:"Automatic Plant Watering System",
        desc:"Description: This project involves building an automated system that waters plants when the soil is dry. It can be made using a few basic electronic components and is a great way to teach kids about electronics and how to take care of plants.",
        link:"/webiste",
        image:require('../src/images/gallery/plantWatering.jpg')
    },
    {
        name:"DIY Pencil Holder",
        desc:"This project involves making a pencil holder using materials like cardboard, paper cups, and glue. It's a great way to teach kids about recycling and repurposing materials.",
        link:"/webiste",
        image:require('../src/images/gallery/pencil.jpeg')
    },
    {
        name:"Safety alarm using Arduino Uno",
        desc:"In this project we will be Using an Arduino and an ultrasonic sensor to prototype a safety alarm that sounds when someone comes near to the ultrasonic sensor.",
        link:'/safetyAlaram',
        image:require("../src/images/gallery/securityAlaram.jpg")
        }
        
        ,
    {
        name:"Water Alarm Using Arduino",
        desc:"In this project we will be building a water level indicator using arduino & water sensor.The system would indicate the level of the water (Three different levels) inside a tank with the help of 3 LED and a buzzer to indicate that the tank is full.",
        link:"/waterAlaram",
        image:require('../src/images/gallery/waterAlaram.jpg')
    },
    {
        name:"Build website using HTML & CSS",
        desc:"In this project we will be using HTML and CSS and build a responsive website and depoly it online for free. You can also share this website with your friends.",
        link:"/webiste",
        image:require('../src/images/gallery/html.jpg')
    },

    
    {
        name:"Solar Powered Phone Charger",
        desc:"This project involves building a solar-powered phone charger using a small solar panel and a few electronic components. It's a great way to teach kids about renewable energy and how to build simple electronic circuits.",
        link:"/webiste",
        image:require('../src/images/gallery/solar.jpeg')
    },
    {
        name:"Miniature Greenhouse",
        desc:"This project involves building a small greenhouse using plastic containers and some soil. It's a great way to teach kids about gardening and how to grow their own food.",
        link:"/webiste",
        image:require('../src/images/gallery/green.jpeg')
    },
    {
        name:"LED Flashlight",
        desc:"This project involves building an LED flashlight using a few basic electronic components. It's a great way to teach kids about electronics and how to solder.",
        link:"/webiste",
        image:require('../src/images/gallery/led.jpg')
    },
    {
        name:"DIY Jewelry Holder",
        desc:"This project involves making a jewelry holder using materials like cardboard, paper cups, and glue. It's a great way to teach kids about organization and repurposing materials",
        link:"/webiste",
        image:require('../src/images/gallery/jew.jpeg')
    },
    {
        name:"Magnetic Levitation ",
        desc:" This project involves building a device that can levitate objects using magnets. It's a great way to teach kids about magnetism and how to build simple electronic circuits.",
        link:"/webiste",
        image:require('../src/images/gallery/levitation.webp')
    },
    {
        name:"Homemade Soap",
        desc:"This project involves making soap using natural ingredients like olive oil and coconut oil. It's a great way to teach kids about chemistry and how to make something useful from scratch.",
        link:"/webiste",
        image:require('../src/images/gallery/soap.jpeg')
    },
    {
        name:"DIY Rain Gauge",
        desc:"This project involves building a rain gauge using a plastic bottle and some measuring tape. It's a great way to teach kids about weather and how to measure rainfall.",
        link:"/webiste",
        image:require('../src/images/gallery/rain.jpeg')
    },
    {
        name:"Smart Dustbin",
        desc:"This project involves building a smart dustbin that automatically opens when someone approaches it. It's a great way to teach kids about sensors and how to build simple electronic circuits.",
        link:"/webiste",
        image:require('../src/images/gallery/dustbin.jpeg')
    }
]

export default data;